import React, { Component } from "react";
import MobileHeaderBack from "../../MobileHeaderBack/index";

class VisaSuccessCard extends Component {
  close = () => {
    const { setSuccess } = this.props;
    setSuccess(false);
  };
  navigateToHome = () => {
    window.location.href = "/";
  }

  render() {
    const {
      cardData,
      isMobile,
      styles,
      mobileHeaderStyle,
      isActivePlan,
      setIsActivePlan,
      successTitle = "Awesome!",
      successSubtitle = "You're eligible to activate the offer below.",
      activateButtonLabel = "Activate Now",
      planBgImage = "/images/visa_card_bg.svg",
      planLogo = "/images/visa_logo_white.svg",
      normalCard = true,
    } = this.props;


    const effectiveIsActivePlan = normalCard ? normalCard : isActivePlan;

    function formatDate(dateStr) {
      const date = new Date(dateStr)

      return date.toLocaleDateString('en-GB', {
        weekday: 'short',
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
    }

    const planTitle = cardData?.plan_tier
      ? `${cardData.plan_tier} Plan`
      : "Membership Plan";

    const planDuration =
      cardData?.start_date && cardData?.end_date
        ? `${cardData.start_date} - ${cardData.end_date}`
        : "—";

    const planPrice = cardData?.price_summary
      ? `${cardData.price_summary.currency} ${cardData.price_summary.final_amount}`
      : "--";

    const planDiscount = cardData?.price_summary?.discount_applied
      ? "Discount Applied"
      : "No Discount";

    const activeTill = cardData?.end_date
      ? `Active until ${formatDate(cardData?.end_date)}`
      : "";

    const onActivate = () => {
      if (!normalCard) {
        setIsActivePlan(true);
      }
    };


    return (
      <div className={styles.topsection}>
        {isMobile && (
          <MobileHeaderBack
            themeColor="white"
            styles={mobileHeaderStyle}
            popupClose={this.close}
          />
        )}

        <div className={styles.visa_component}>
          {/* HEADER */}
          <div className={styles.awesome_header}>
            <div className={styles.awesome_icon}>
              <img
                src={
                  effectiveIsActivePlan
                    ? "/images/celebration_icon.svg"
                    : "/images/bb_thumb.svg"
                }
                alt="status_icon"
              />
            </div>

            <div className={styles.awesome_message}>
              <h1 className={styles.awesome_title}>
                {effectiveIsActivePlan ? "Congratulations!" : successTitle}
              </h1>
              <p className={styles.awesome_subtitle}>
                {effectiveIsActivePlan
                  ? `"Great news! An exclusive ${cardData?.plan_tier || ""} offer is now unlocked just for you - ready to explore and enjoy."`
                  : successSubtitle}
              </p>
            </div>
          </div>

          {/* PLAN CARD */}
          <div className={styles.plan_card_wrapper}>
            <div className={styles.plan_card}>
              <div className={styles.plan_card_background}>
                <img
                  src={planBgImage}
                  alt="Plan background"
                  className={styles.plan_card_bg_image}
                />
              </div>

              <div className={styles.plan_card_content}>
                <div className={styles.plan_card_logo}>
                  <img src={planLogo} alt="Logo" />
                </div>

                <div className={styles.plan_card_body}>
                  <div className={styles.plan_card_left}>
                    <h3 className={styles.plan_card_title}>{planTitle}</h3>
                    <p className={styles.plan_card_duration}>{cardData?.display_plan_duration}</p>
                  </div>

                  <div className={styles.plan_card_price}>
                    <span className={styles.plan_price_amount}>
                      {planPrice}
                    </span>
                    <span className={styles.plan_price_discount}>
                      {planDiscount}
                    </span>
                  </div>
                </div>

                {effectiveIsActivePlan && (
                  <div className={styles.plan_card_action}>
                    <div className={styles.plan_card_active_text}>
                      {activeTill}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* FOOTER ACTIONS */}
            <div className={styles.plan_card_footer}>
              {!effectiveIsActivePlan ? (
                <button
                  className={styles.plan_activate_button}
                  onClick={onActivate}
                >
                  {activateButtonLabel}
                </button>
              ) : (
                <button
                  className={`${styles.plan_activate_button} ${styles.explore_button}`}
                  onClick={this.navigateToHome}
                >
                  Explore Experiences
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default VisaSuccessCard;
